import { useVistaFeatureFlag } from '../utils/useVistaFeatureFlag';

export function useProLogoDesignFeatureFlag(esMpvId: string) {
    return useVistaFeatureFlag('design_services_pro_logo_design', [
        { value: esMpvId.toLowerCase(), must: 'prologodesign' },
    ]);
}
